import React, {useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import Api from '../../../inc/Api'
import Settings from '../../../inc/Settings'
import { exportToXlsx, getPopupMessageBasedOnStatus } from '../../../inc/Validation'
import Helper from '../../../inc/Helper'
import NavigationHeder from '../../../components/Navigations/NavigationHeder'
import AgGridNew from '../../../components/grid/ag/ag-grid-new'
import { generateBaseUrl, getLabelFromDropdown, getOptions, optionsKeyCreator } from '../../../components/grid/ag/commonFunctions/GridCommonFunctions'
import NewOverlayLoader from '../../../components/PurchaseRequisition/common/NewOverlayLoader'
import MasterComponentWraper from '../../../components/Backend/MasterComponentWraper'
import SimpleDropdown from '../../../components/grid/ag/cellEditor/SimpleDropdown'
import { transformObjectEmailNotifications } from '../../../inc/TransformerFunctions'

/* validation -> Event is mandatory field */

let forceRender = 0;
let gridApi = null;
let AddBtn;
let transaction;

const EmailNotificationsArchieve = (props) => {
  const [events, setEvents] = useState([])
  const [emailTemplates, setEmailTemplates] = useState([])
  const [teams, setTeams] = useState([])
  const [exportLoading, setExportLoading] = useState(false);

  let eventsCalled = false
  let emailTemplatesCalled = false

  useEffect(() => {
    getEvents()
    getTeamsforEmail()
    getEmailTemplates()
  }, [])

  const getEvents = () => {
    if (eventsCalled) return

    let api = Api
    eventsCalled = true
    api.setUserToken()
    api
      .axios()
      .get(Settings.apiUrl + `/events?workflow_events=true`)
      .then(function (res) {
        if (res.data.status === 'success') {
          setEvents(
            res?.data?.data?.map((element) => {
              return {
                value: element.event_id,
                label: element.event_name,
              }
            })
          )
          forceRender++
        }
      })
      .catch((res) => {
        getPopupMessageBasedOnStatus(res)
      })
  }

  const getTeamsforEmail = () => {
    let api = Api
    api.setUserToken()
    api
      .axios()
      .get(Settings.apiUrl + `/teamheader?dynamic_team_header=false`)
      .then(function (res) {
        if (res.data.status === 'success') {
          setTeams(
            res?.data?.data?.map((element) => {
              return {
                value: element.teamheader_id,
                label: element.name,
              }
            })
          )
          forceRender++
        }
      })
      .catch((res) => {
        getPopupMessageBasedOnStatus(res)
      })
  }

  const getEmailTemplates = () => {
    if (emailTemplatesCalled) return

    let api = Api
    emailTemplatesCalled = true
    api.setUserToken()
    api
      .axios()
      .get(Settings.apiUrl + '/emaildetails')
      .then(function (res) {
        if (res.data.status === 'success') {
          setEmailTemplates(
            res?.data?.data?.map((element) => {
              return {
                value: element.emaildetail_id,
                label: element.name ?? element.subject,
              }
            })
          )
        }
      })
      .catch((res) => {
        getPopupMessageBasedOnStatus(res)
      })
  }
  
  const handleBtn = (value, transactionData) => {
    AddBtn = value
    transaction = transactionData
  };

  const onRowValueChanged = (event) => {
    if (event?.data?.rec_id) {
      updateNotificationsEvents(event)
    } else {
      postNotificationsEvents(event)
    }
  };

  const updateNotificationsEvents = async (event) => {
    const { trigger_push_notification, trigger_email, emailtemplate_id } = event.data;
    try {
      let payload = {
        trigger_push_notification: trigger_push_notification ? true : false,
        trigger_email: trigger_email ? true : false,
        emailtemplate_id: emailtemplate_id ? parseInt(emailtemplate_id) : ''
      };

      let api = Api
      api.setUserToken()
      const res = await api.axios().put(Settings.apiUrl + `/triggernotification/${event?.data?.rec_id}`, payload)
      if (res.data.status === 'success' || res.data.success) {
        setTimeout(() => {
          gridApi?.api?.refreshServerSide({ purge: true });
          gridApi?.api?.deselectAll();
        }, 100);
        Helper.alert(res?.data?.message);
      }
    } catch (error) {
      getPopupMessageBasedOnStatus(error)
    }
  };

  const postNotificationsEvents = async (event) => {
    const { event_id, trigger_push_notification, trigger_email, emailtemplate_id } = event.data;
    try {
      let payload = {
        event_id: parseInt(event_id),
        trigger_push_notification: trigger_push_notification ? true : false,
        trigger_email: trigger_email ? true : false,
        emailtemplate_id: emailtemplate_id ? parseInt(emailtemplate_id) : null
      };

      let api = Api
      api.setUserToken()
      const res = await api.axios().post(Settings.apiUrl + '/triggernotification', payload)
      if (res.data.status === 'success' || res.data.success) {
        setTimeout(() => {
          gridApi?.api?.refreshServerSide({ purge: true });
          gridApi?.api?.deselectAll();
        }, 100);
        setTimeout(() => {
          if (AddBtn) {
            gridApi?.api?.applyServerSideTransaction(transaction);
          }
        }, 1000);
        Helper.alert(res?.data?.message);
      }
    } catch (error) {
      getPopupMessageBasedOnStatus(error)
    }
  };

  /* Grid Column Headers */
  const gridColumnHeader = [
    {
      field: 'event_id',
      headerName: 'Event',
      editable: (params) => !params?.data?.rec_id,
      cellEditor: SimpleDropdown,
      isAllowZero:true,
      inputId: 'event_id',
      minWidth:180,
      cellEditorParams: {
        values: events
      },
      cellDataType:false,
      valueFormatter: (params)=> getLabelFromDropdown(params),
      filter:'agSetColumnFilter',
      filterParams: {
        values: (params) => getOptions(params, events),
        keyCreator: (params) => optionsKeyCreator(params, 'value'),
        valueFormatter: params => params.value.label
      }
    },
    {   
      field:'trigger_push_notification', filter: 'agSetColumnFilter', 
      filterParams: { 
        values: [true, false], 
        keyCreator: (params) => params.value, 
        valueFormatter: (params) => params.value ? 'true' : 'false' 
      }, 
      editable: true, 
      headerName: 'Trigger push notification', 
      cellRenderer: 'agCheckboxCellRenderer',
      cellEditor: 'agCheckboxCellEditor',
      cellRendererParams: { disabled: true },
      valueGetter: (params) => {
        if(!params?.data?.trigger_push_notification || !params?.data){
          return false
        }
        else {
          return params.data?.trigger_push_notification
        }
      }
    },
    {
      field: 'emailtemplate_id',
      headerName: 'Email templates',
      editable: true,
      cellEditor: SimpleDropdown,
      isAllowZero:true,
      inputId: 'email_template_id',
      minWidth:180,
      cellEditorParams: {
        values: emailTemplates
      },
      cellDataType:false,
      valueFormatter: (params)=> getLabelFromDropdown(params),
      filter:'agSetColumnFilter',
      filterParams: {
        values: (params) => getOptions(params, emailTemplates),
        keyCreator: (params) => optionsKeyCreator(params, 'value'),
        valueFormatter: params => params.value.label
      }
    },
    {
      field:'trigger_email', filter: 'agSetColumnFilter', 
      filterParams: { 
        values: [true, false], 
        keyCreator: (params) => params.value, 
        valueFormatter: (params) => params.value ? 'true' : 'false' 
      }, 
      editable: true, 
      headerName: 'Trigger email', 
      cellRenderer: 'agCheckboxCellRenderer',
      cellEditor: 'agCheckboxCellEditor',
      cellRendererParams: { disabled: true },
      valueGetter: (params) => {
        if(!params?.data?.trigger_email || !params?.data){
          return false
        }
        else {
          return params.data?.trigger_email
        }
      }
    },
    {
      field: 'cc_members',
      headerName: 'Email cc members',
      editable: true,
      cellEditor: SimpleDropdown,
      isAllowZero:true,
      inputId: 'email_cc_members',
      minWidth:180,
      cellEditorParams: {
        values: teams
      },
      cellDataType:false,
      valueFormatter: (params)=> getLabelFromDropdown(params),
      filter:'agSetColumnFilter',
      filterParams: {
        values: (params) => getOptions(params, teams),
        keyCreator: (params) => optionsKeyCreator(params, 'value'),
        valueFormatter: params => params.value.label
      }
    }
  ];

  const getTransformedObjForExport = (data) => transformObjectEmailNotifications(data, events, emailTemplates, teams);

  const exportData = async () => {
    setExportLoading(true);

    const apiUrl = Settings.apiUrl + '/triggernotification';
    const params = '?workflow_events=true';

    let pagination = false;
    let defaultAdvanceFilterObj = false; 

    const baseUrl = generateBaseUrl({ gridObj: gridApi, apiUrl, params, pagination, defaultAdvanceFilterObj });
    await exportToXlsx({ url: baseUrl, columns: (gridColumnHeader), fileName: "email_notification_details", additionalFunction: getTransformedObjForExport });
    
    setExportLoading(false);
  };

  const onDeleteEmailNotifications = useCallback(async (element) => {
    let api = Api
    api.setUserToken()
    try {
      const res = await api.axios().delete(Settings.apiUrl + `/triggernotification/${element.rec_id}`)
      const rowNode = gridApi?.api?.getRowNode(element?.data?.rec_id)
      if (rowNode) {
        rowNode.setSelected(false)
      }

      setTimeout(() => {
        const transaction = { remove: [element.data] }
        gridApi?.api?.applyServerSideTransaction(transaction)
      }, 200);

      gridApi?.api?.refreshServerSide({ purge: true })
      gridApi?.api?.deselectAll();

      Helper.alert(res?.data?.message, 'success')
    } catch (err) {
      getPopupMessageBasedOnStatus(err)
    }
  }, []);

  return (
    <div className='emails_template_archive'>
      {exportLoading ? <NewOverlayLoader /> : null}

      <NavigationHeder title='Notifications' hideMoreBtn={true} />

      <AgGridNew
        apiUrl={Settings.apiUrl + '/triggernotification'}
        pagination={false}
        columnDefs={gridColumnHeader}
        onRowValueChanged={onRowValueChanged}
        handleDeleteSelectedRows={onDeleteEmailNotifications}
        height={500}
        onGridReady={(params) => gridApi = params}
        handleAddButton={handleBtn}
        additionalParams={`?workflow_events=true`}
        filterAdditionalParams={`?workflow_events=true`}
        uniqueField={`rec_id`}
        hideDeleteBtn={true}
        gridId={'rs_notification_event_list'}
        afterDeleteBtns={
          <div className="import_sample_template px-2 ms-auto">
            <button onClick={exportData}>
              <img className="img-fluid" src="/images/icons/excel-logo.svg" alt="excel-logo" /> Export
            </button>
          </div>
        }
        btnsWrapperStyle="w-100 px-2"
      />
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    appOptions: state.options,
    auth: state.auth,
    language: state.language,
  }
}

export default connect(mapStateToProps) (MasterComponentWraper(EmailNotificationsArchieve)); 